import { SEVERITY, STATUS_BADGE } from "@/theme/tokens";
import { RecommendationType, Severity } from "@/utils/models";

export const RecommendationsTitle = {
	[RecommendationType.PostShift]: "Shift Understaffed",
	[RecommendationType.ApproveRequest]: "Shift Understaffed",
	[RecommendationType.ApproveReplacementRequest]: "Staff Request",
	[RecommendationType.RemoveStaff]: "Shift Overstaffed",
} as const satisfies Record<RecommendationType, string>;

export const RecommendationsSubTitle = {
	[RecommendationType.PostShift]: "Post a Shift",
	[RecommendationType.ApproveRequest]: "Approve Request",
	[RecommendationType.ApproveReplacementRequest]: "Approve Replacement",
	[RecommendationType.RemoveStaff]: "Call off Staff",
} as const satisfies Record<RecommendationType, string>;

export const SeverityColors = {
	[Severity.High]: SEVERITY.HIGH,
	[Severity.Medium]: SEVERITY.MEDIUM,
	// brand fallback — does not re-tint with user theme
	[Severity.Low]: STATUS_BADGE.BRAND_FALLBACK,
} as const satisfies Record<Severity, string>;
